/* eslint-disable */
/* rgisterPage.vue */
<template>
    <div>
        <div class="modal-container" v-if="showModal">
            <div class="overlay" ></div>
            <div class="content-wrapper" >
                <div class="modal-content">
                    <div v-html="msgCallBack"></div>
                    <button @click="toCallBack">{{ btnCallBack }}</button>
                </div>
            </div>
        </div>
        <div class="newMessage">
            <newMessage :msg="msg"  />
        </div>
    </div>
</template>





<script>
import newMessage from "@/components/newMessage.vue";

import  moment  from 'moment-timezone'; 

export default {
    components: { newMessage},
  props: {
  },
    data() {
        return {
            tabulator: {},
            formData: { ...this.registerForm(), data:{}},
            data: {},
            showModal: false,
            callBack: "",
            msgCallBack: "",
            btnCallBack: "",
            msg: {msg:"",time:0},
            showMsg: false
        }
    },
    mounted() {
        // eslint-disable-next-line 
        //debugger;
        this.$eventBus.on("redirectPage",this.callRedirectPage)
        this.$eventBus.on("newMessage",this.showMessage)
    },
    methods: {
        showMessage(msg) {
            this.msg = msg;
            this.showMsg=true;
        },
        callRedirectPage(redir) {
            console.log("callRedirectPage:",redir)
            this.callBack = redir.callBack
            this.msgCallBack = redir.msgCallBack
            this.btnCallBack = redir.btnCallBack
            this.showModal = true
        },
        toCallBack() {
            window.location.href = this.callBack;
        },
        onBuilded() { 
                console.log("click on tableBuilt")
                const btn = document.getElementById('add-edit-btn');
                const parent = btn.parentElement
                parent.style.display = "flex !important";
                btn.style.marginLeft= "auto !important"
                btn.addEventListener('click', this.toggleModal.bind(this)); 
        },

       
        saveRow(rowData) {
            this.$ajax("save_promotion",rowData, "promotion_data", );
        },
       
        dateEditor(cell, onRendered, success, cancel) {
            var cellValue = cell.getValue(),
            input = document.createElement("input");
            input.addEventListener("blur", onChange);
            input.setAttribute("type", "text");
            input.style.width = "100%";
            input.value = cellValue;

            onRendered(function() {
                input.focus();
                input.style.height = "100%";
            });

            function onChange() {
                if (input.value.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/)) {
                    success(input.value);
                } else {
                    cancel();
                    alert("Formato de fecha y hora incorrecto. Utilice YYYY-MM-DD HH:MM");
                }
            }

        
            input.addEventListener("keydown", function(e) {
                if (e.keyCode == 13) {
                    onChange();
                } else if (e.keyCode == 27) {
                    cancel();
                }
            });

            return input;
        },
        datetimeFormatter(cell) {
            const dataRow = cell.getData();
            const field = cell.getField();
            if (field != "start_datetime" && field != "end_datetime") return dataRow[field];
            
            const ini = moment(dataRow["start_datetime"]).tz("America/Bogota", true); 
            const end = moment(dataRow["end_datetime"]).tz("America/Bogota", true);
            const current = moment().tz("America/Bogota");

            const color = (current.isBetween(ini, end)) ? "#d5fae7" : "transparent";
            return `<div style="background-color:${color}">${dataRow[field]}</div>`;
        },
        showImageFormatter(cell) {
            let url = cell.getValue();
            if (!url) return `<img src="" style="width:90px;height:auto;"></img>`;
            return `<div style="width:90px;height:80px;overflow:hidden;border:1px solid #ccc;"><img src="${url}" style="width:90px; height:auto;"></div>`;
        },
        registerForm() {
            console.log("registerForm:", window.registerForm)
            return (window.registerForm) ? window.registerForm :  {
                "title": "Datos Evento",
                "collection": "",
                "idForm": "",
                "keyDB": "name",
                "onSubmit": "api",
                "valid": {
                    "event_purpose@event": { "type": "required", "msg": "El tipo de evento es requerido" },
                    "event_date@event": { "type": "isDate", "msg": "Fecha no valida" },
                    "event_location@event": { "type": "length", "minLength": 3, "maxLength": 100, "msg": "Longitud entre 3 y 100 caracteres" },
                },
                "class": { rows: {}, cols: {}, subs: {}, groups: {} },
                "styles": { form: "", rows: {}, cols: {}, subs: {}, groups: {}, fields: {} },
                "vIf": { rows: {}, cols: {}, subs: { 20: { "field": "number_of_hosts@event", "signo": "==", "value": 2 } }, groups: {}, fields: {} },
                "fields": {
                        "event_id@event": { col: 0, "row": 1, "num": 2, "group": 0, "type": "text", "class": "", "id": "event_id@event", "required": true, "label": "Id del Evento", "readonly": true },
                        "number_of_hosts@event": { "col": 0, "row": 5, "num": 1, "group": 0, "type": "component", "onChange": false, "component": { "id": "listBoxInput", "alwaysList": true, "options": [{ id: "1", "label": "Uno" }, { id: "2", "label": "Dos" }], "from": "", "collection": "", "field": "id", "show": "<strong>{{label}}</strong>", "key": "{{id}}", "set": {}, "col": 1, "numRows": 5 }, "class": "", "id": "number_of_hosts@event", "required": true, "label": "Numero de Anfitriones" },
                        "event_purpose@event": { col: 0, "row": 5, "num": 2, "group": 0, "type": "radio", "radio": [{ "value": 1, "label": "Matrimonio" }, { "value": 2, "label": "Shower" }], "class": "", "id": "event_purpose@event", "required": true, "label": "Tipo de Evento", "readonly": false },
                        "event_date@event": { "col": 4, "row": 6, "num": 21, "group": 25, "type": "datetime-local", "class": "", "id": "event_date@event", "required": true, "label": "Fecha" },
                        "event_location@event": { "col": 4, "row": 6, "num": 22, "group": 25, "type": "text", "placeholder": "Lugar", "onChange": false, "class": "", "id": "event_location@event", "required": true, "label": "Lugar" },

                        "g40": { "col": 8, "row": 12, "num": 40, "type": "label", "class": "mt-5 h4 text-start",  "label": "Modalidad de la lista de regalos" },
                        "tradicional@event": { "col": 8, 'default': true, "row": 12, "num": 41, "group": 29, "type": "checkbox", "class": "", "id": "tradicional@event", "required": false, "label": "Lista Tradicional", "msg": "<p style='text-align: justify; margin: 0; max-width:70%'> Elije los productos de tu preferencia para la lista de regalos. Podras optar por recibir regalod en la direccion indicada, en una unica entrega programada, la cual no podrá ser mayor aun mes despues de la fecha del evento.</p>" },
                        "bolsa@event": { "col": 8, "row": 12, 'default': false, "num": 42, "group": 29, "type": "checkbox", "placeholder": "Bolsa", "onChange": false, "class": "", "id": "bolsa@event", "required": false, "label": "Bolsa de dinero", "msg": "<p style='text-align: justify; margin: 0; max-width:70%'>Los invitados compran bonos que se agregan a una bolsa de dinero a nombre de los anfitriones. Al finalizar la lista, los anfitriones recibiran el monto total recolectado y podran utilizarlo para redimirlo en nuestras tiendas. Se establecen fechas de cierre de la lista y de redencion del bono, con un plazo de un año para redimirlo.</p>" },

                        "g45": { "col": 9, "row": 14, "num": 22, "type": "label", "class": "mt-5 h4 text-start",  "label": "Crea la portada de tu lista y personaliza la apariencia de tus invitados" },
                        "image_url@event": { "col": 9, "row": 14, "num": 23, "group": 35, "type": "image", "placeholder": "", "onChange": false, "class": "", "id": "image_url@event", "required": false, "label": "Adjunta una imagen", msg: "<p class='ml-3 w-60 mr-3'>Personaliza la apariencia de tu lista adjuntando una imagen en forma horizontal de 1367 x 608 px con peso maximo de 500 Kb</p>" },
                        
                        "g50": { "col": 10, "row": 15, "num": 43, "type": "label", "class": "mt-5 h4 text-start",  "label": "Aceptar" },
                        "acceptPolicy@event": { "col": 10, "row": 15, 'default': false, "num": 44, "group": 40, "type": "checkbox", "placeholder": "", "onChange": false, "class": "", "id": "acceptPolicy@event", "required": true, "label": "Acepto terminos del contrato", "msg": "<p style='text-align: justify; margin: 0; margin-left:15px; max-width:70%;color:grey'>Acepta la politica de tratamiento de datos y terminos del contrato <a href='/contrato' target='_blank'>Ver Contrato</a></p>" },
                    },
                    "getAction": "get_data_event",
                    "setAction": "update_data_event",
                    "deleteAction": "",
                    "preloadData": "get_data_event"
                }
            }

        }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.add-edit-btn {
  border: 1px solid #82868a;
  border-radius: 15px; 
}
/* Estilos para la barra de desplazamiento */
::-webkit-scrollbar {
    width: 15px; /* Ajusta el ancho de la barra de desplazamiento vertical */
    height: 15px; /* Ajusta el alto de la barra de desplazamiento horizontal */
}

/* Estilos para el track de la barra de desplazamiento */
::-webkit-scrollbar-track {
    background: #f7f6f6; /* Color de fondo del track */
}

/* Estilos para el thumb (la parte que se desplaza) de la barra */
::-webkit-scrollbar-thumb {
    background: #888; /* Color de fondo del thumb */
}

/* Cambia el color del thumb al pasar el mouse */
::-webkit-scrollbar-thumb:hover {
    background: #555; /* Color de fondo del thumb al pasar el mouse */
}
#appTabulator {
    max-height: 100%;
    overflow: auto; /* Muestra barras de desplazamiento cuando el contenido excede el tamaño del contenedor */
}


.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 101;
}

.content-wrapper {
    background-color: #fff;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    width: 80%;
    max-width: 600px;
    position: relative;
    z-index: 102;

}

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: visible;
  z-index: 100;
}
.dynamicFormContainer {
     z-index: 10;
}

button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

</style>
